export default __webpack_public_path__ + "static/media/twitterNew.72dda6be.svg";